import { Select } from 'antd';
import type { SelectOption } from '@/types';
import { AcaoEnum } from '@/features/log/types/enum';

export const options: SelectOption<AcaoEnum>[] = [
    { label: 'Inserção', value: AcaoEnum.Insercao },
    { label: 'Alteração', value: AcaoEnum.Alteracao },
    { label: 'Exclusão', value: AcaoEnum.Exclusao },
];

export function SelectAcao({
    placeholder,
    value,
    onChange,
}: {
    placeholder?: string;
    value?: AcaoEnum[];
    onChange?: (value: AcaoEnum[], option: SelectOption<AcaoEnum>[]) => void;
}) {
    const handleChange = (
        value: AcaoEnum[],
        option?: SelectOption<AcaoEnum> | SelectOption<AcaoEnum>[],
    ): void => {
        const normalized = Array.isArray(option) ? option : option ? [option] : [];

        onChange?.(value, normalized);
    };

    return (
        <Select
            allowClear
            className='w-full'
            mode='multiple'
            onChange={handleChange}
            options={options}
            placeholder={placeholder}
            value={value}
        />
    );
}
